import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { CaseDocument } from '../../models/caseDocument';
import { Case } from '../../models/casehistory';
import { CaseDocDialogOverview } from '../case-documents/case-documents.component';

@Component({
  selector: 'app-case-summary',
  templateUrl: './case-summary.component.html',
  styleUrls: ['./case-summary.component.scss']
})
export class CaseSummaryComponent implements OnInit {
  displayedColumns: string[] = ['nnotes', 'datetime', 'noteenterBy'];
  dataSource:any=[];
  caseDocuments:CaseDocument[]=[];
caseDetails:Case;
  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private caseManagementService:CaseManagementService,
    private dialogRef: MatDialogRef<CaseSummaryComponent>,
    private lightbox: Lightbox,
    public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService
  ) {
    if (data) {
      this.caseDetails=data.caseData;
    
    }
  }

  ngOnInit() {
    this.getCaseDocuments();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  getCaseDocuments() {
    this.loaderService.show();
    this.caseManagementService
      .getCaseDocuments(
        this.caseDetails.id
      )
      .subscribe((res) => {
        this.caseDocuments=res.result;
        this.loaderService.hide();

      }, (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
  }
  viewFile(doc: CaseDocument) {
    const dialogRef = this.dialog.open(CaseDocDialogOverview, {
      id: "view-dialog",
      width: '80%',
      height: '80%',
      hasBackdrop: true,
      data: doc
    });
}
}